import { render, staticRenderFns } from "./CreateKisok.vue?vue&type=template&id=57cb5516"
import script from "./CreateKisok.vue?vue&type=script&lang=js"
export * from "./CreateKisok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports